export const data = {
    en: {
      paragraphs: [
        {
          title: 'Exchange program',
          text: 'We promote cultural and academic exchanges between Germany and China, and support governmental organizations (such as vocational schools, municipal administrations) in organizing and running exchange programs for students, students, and teachers.',
        },
        {
          title: 'Internship program',
          text: 'In order to establish a nationwide uniform training of automotive mechatronics in China, we are developing not only the projects for training with the Chinese schools, but also the internship program.',
        },
        {
          title: '',
          text: 'The successful transition into working life is the decisive step on the way to a self-determined life for all students. In the traineeship program, the Chinese students have the opportunity not only to be trained in China for the German dual vocational training system, but also to inform themselves in Germany about job profiles, the world of work and the necessary qualifications first hand and then first practical impressions of suitable To get jobs.',
        },
      ],
    },
    de: {
      paragraphs: [
        {
          title: 'Austauschprogramm',
          text: 'Wir fördern den Kultur- und Wissenschaftsaustausch zwischen Deutschland und China, unterstützen staatliche Organisationen (z.B. berufsbildende Schulen, kommunale Verwaltungen) bei der Organisation und Durchführung von Austauschprogrammen von Schülerinnen, Schülern, Studierenden und Lehrenden.',
        },
        {
          title: 'Praktikumsprogramm',
          text: 'Um eine landesweit einheitliche Ausbildung von Kfz-Mechatronikern in China zu etablieren, entwickeln wir nicht nur die Projekte zur Ausbildung mit den chinesischen Schulen, sondern auch das Praktikantenprogramm.',
        },
        {
          title: '',
          text: 'Der erfolgreiche Übertritt ins Berufsleben ist für alle Schüler der entscheidende Schritt auf dem Weg in ein selbst bestimmtes Leben. Bei dem Praktikantenprogramm haben die chinesischen Schüler die Möglichkeiten, nicht nur in China nach dem deutschen dualen Berufsausbildungssystem ausgebildet zu werden, sondern auch sich in Deutschland über Berufsbilder, über die Arbeitswelt sowie über erforderliche Qualifikationen aus erster Hand zu informieren und dann erste praktische Eindrücke über passende Berufe zu erhalten.',
        },
      ],
    },
};